import React from 'react'

import { useModelState } from '../../model-hooks/use-model-state'
import ChartLayout from '../../models/chart_layout'
import { AutoSaveState } from '../../models/constants'

interface LoadLatestDataButtonProps {
  chartLayoutModel: ChartLayout
}

export function AutoSaveStateIndicator({ chartLayoutModel: unwatchedChartLayoutModel }: LoadLatestDataButtonProps) {
  const chartLayoutModel = useModelState(unwatchedChartLayoutModel, { watchProperties: ['autoSaveState'] })!
  const [isVisible, setIsVisible] = React.useState(false)
  const { autoSaveState } = chartLayoutModel

  React.useEffect(() => {
    if (autoSaveState.every((item) => item === AutoSaveState.Off)) {
      return
    }

    let setVisibilityTimeout: NodeJS.Timeout | null = null
    const newIsVisible = autoSaveState.some((item) => item !== AutoSaveState.Saved)

    setVisibilityTimeout = setTimeout(
      () => {
        setIsVisible(newIsVisible)
      },
      newIsVisible ? 0 : 3000
    )

    const checkIfNeededPreventLeaving = (event: BeforeUnloadEvent) => {
      if (autoSaveState.every((item) => item === AutoSaveState.Saved)) {
        return undefined
      }

      const message = `Your latest changes haven't been saved yet. If you leave now, your changes might be lost.`
      event.returnValue = message
      return message
    }

    window.addEventListener('beforeunload', checkIfNeededPreventLeaving)

    return () => {
      window.removeEventListener('beforeunload', checkIfNeededPreventLeaving)
      if (setVisibilityTimeout) {
        clearTimeout(setVisibilityTimeout)
      }
    }
  }, [autoSaveState])

  if (!isVisible) {
    return null
  }

  // @todo - add proper indicator component here
  return null
}
